import styled from 'styled-components'

export const CardActionContainer = styled.div`
  background-color: white;
  padding: 1rem;
  max-width: 768px;
`
